import { render, staticRenderFns } from "./application.vue?vue&type=template&id=36ec0f73&"
import script from "./application.vue?vue&type=script&lang=js&"
export * from "./application.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36ec0f73')) {
      api.createRecord('36ec0f73', component.options)
    } else {
      api.reload('36ec0f73', component.options)
    }
    module.hot.accept("./application.vue?vue&type=template&id=36ec0f73&", function () {
      api.rerender('36ec0f73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/app-manage/application-manage/application.vue"
export default component.exports